import {$http, Constants} from '@/store/actions/constants';

export const DocumentAction = {
    AddOrUpdate: ({commit, state}, payload) => {
        if (payload.documentID) {
            return $http.put(
                `${url}/${payload.documentID}`, payload.data, state.authHeader);
        } else {
            return $http.post(url, payload.data, state.authHeader);
        }
    },

    All: ({commit, state}, userId) => {
        return $http.get(`${url}?user_id=${userId}`, state.authHeader);
    },

    Get: ({commit, state}, documentId) => {
        return $http.get(`${url}/${documentId}`, state.authHeader);
    },
};

const url = `${Constants.BaseURL}/document`;